import type DepotDto from "smavesto.core/lib/types/dto/depot/DepotDto";

export function sortDepots(a: DepotDto) {
  if (a.customerDepotRelationshipType === "Parent") return 1;

  return -1;
}
